export default {
    // ----------Title----------
    parcels: '包裹',
    newParcel: '添加包裹',
    ownership: '所有权',
    provideDetailsOfTheProfile: '提供档案详细信息',
    parcelDetails: '包裹',
    provideTheInfoOfTheParcel: '提供包裹详细信息',
    measurement: '尺寸',
    provideDetailItemMeasurement: '提供尺寸详细信息',
    theItemReceiveAndDeliveryOrderWillCreateAutomatically: '接收物品和发货单将自动创建。',

    // -----------MUI----------
    productCode: '产品编码',
    quantity: '数量',
    uom: '计量单位',
    pricePerUnit: '单价',
    volumeWeight: '体积重量',
    grossWeight: '总重量',
    netWeight: '净重',
}